import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash, faPlus } from "@fortawesome/free-solid-svg-icons";

import Select from "react-select";
import cc from "currency-codes";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

const countries = cc.countries().map((name) => ({
  value: name,
  label: name,
}));

const Base_Url = process.env.REACT_APP_BASE_URL;

const UserProfileAdmin = ({ user, role }) => {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);

  const handleEditButtonClick = () => {
    if (user._id) {
      navigate(`/edit/user/${user._id}`);
    }
  };

  return (
    <>
      <div className="user-details-container view-user">
        <div className="profile-container">
          <p></p>
          <div className="profile-photo-container">
            <p>Profile Photo</p>
            <div className="profile-photo">
              {user.profilePhoto ? (
                <img
                  src={`${Base_Url}/assets/profilePhotos/${user.profilePhoto}`}
                  alt="Profile"
                />
              ) : (
                <FontAwesomeIcon icon={faPlus} />
              )}
            </div>
          </div>
        </div>
        {role === "admin" ? (
          <div className="details-container">
            <div className="contact-details">
              <div className="edit-btn-container">
                <button
                  type="button"
                  className="editBtn"
                  onClick={handleEditButtonClick}
                >
                  Edit
                </button>
              </div>
              <h2>User Details</h2>
              <div className="input-group">
                <input
                  type="text"
                  name="firstName"
                  value={user.firstName}
                  disabled
                  placeholder="First Name"
                />
                <input
                  type="text"
                  name="lastName"
                  value={user.lastName}
                  disabled
                  placeholder="Last Name"
                />
              </div>
              <div className="input-group">
                <input
                  className="emailInput"
                  type="email"
                  name="email"
                  value={user.email}
                  disabled
                  placeholder="Email"
                />
                <div className="edit-password-container">
                  <input
                    type={showPassword ? "text" : "password"}
                    name="password"
                    value={user.password}
                    disabled
                    placeholder="Password"
                  />
                  <FontAwesomeIcon
                    icon={showPassword ? faEyeSlash : faEye}
                    className="password-icon"
                    onClick={() => setShowPassword(!showPassword)}
                  />
                </div>
              </div>
              <Select
                className="country-select"
                options={countries}
                value={countries.find(
                  (country) => country.value === user.country
                )}
                isDisabled
                placeholder="Country"
              />

              <div className="input-group">
                <input
                  type="text"
                  name="accountNumber"
                  value={user.bankDetails?.accountNumber}
                  disabled
                  placeholder="Account Number"
                />
                <input
                  type="text"
                  name="accountHolderName"
                  value={user.bankDetails?.accountHolderName}
                  disabled
                  placeholder="Account Holder Name"
                />
              </div>

              <div className="input-group">
                <input
                  type="text"
                  name="bankName"
                  value={user.bankDetails?.bankName}
                  disabled
                  placeholder="Bank Name"
                />
                <input
                  type="text"
                  name="bankAddress"
                  value={user.bankDetails?.bankAddress}
                  disabled
                  placeholder="Bank Address"
                />
              </div>
              {(user.bankDetails?.ifscCode || user.bankDetails?.swiftCode) && (
                <div className="input-group">
                  <input
                    type="text"
                    name="ifscCode"
                    value={user.bankDetails?.ifscCode}
                    disabled
                    placeholder="IFSC Code"
                  />
                  <input
                    type="text"
                    name="swiftCode"
                    value={user.bankDetails?.swiftCode}
                    disabled
                    placeholder="SWIFT Code"
                  />
                </div>
              )}
              {(user.bankDetails?.transitCode ||
                user.bankDetails?.institutionNumber) && (
                <div className="input-group">
                  <input
                    type="text"
                    name="transitCode"
                    value={user.bankDetails?.transitCode}
                    disabled
                    placeholder="Transit Code"
                  />
                  <input
                    type="text"
                    name="institutionNumber"
                    value={user.bankDetails?.institutionNumber}
                    disabled
                    placeholder="Institution number"
                  />
                </div>
              )}
            </div>

            {(user?.eTranferEmail || user?.paypalEmail) && (
              <div className="contact-dynamic-details">
                {user?.eTranferEmail && (
                  <div className="contact-inner-details">
                    <h2>E-Transfer Details</h2>
                    <div className="input-groupp">
                      <input
                        className="emailInput"
                        type="email"
                        name="eTranferEmail"
                        value={user.eTranferEmail}
                        disabled
                        placeholder="Email"
                      />
                    </div>
                  </div>
                )}
                {user?.paypalEmail && (
                  <div className="contact-inner-details">
                    <h2>PayPal Details</h2>
                    <div className="input-group">
                      <input
                        className="emailInput"
                        type="email"
                        name="paypalEmail"
                        value={user.paypalEmail}
                        disabled
                        placeholder="Email"
                      />
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        ) : (
          <div className="details-container">
            <div className="contact-details">
              <h2>User Details</h2>
              <div className="input-group">
                <input
                  type="text"
                  name="firstName"
                  value={user.firstName}
                  disabled
                  placeholder="First Name"
                />
                <input
                  type="text"
                  name="lastName"
                  value={user.lastName}
                  disabled
                  placeholder="Last Name"
                />
              </div>
              <div className="input-group">
                <input
                  className="emailInput"
                  type="email"
                  name="email"
                  value={user.email}
                  disabled
                  placeholder="Email"
                />
                <Select
                  className="country-select user-view"
                  options={countries}
                  value={countries.find(
                    (country) => country.value === user.country
                  )}
                  isDisabled
                  placeholder="Country"
                />
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default UserProfileAdmin;
